import axios from "axios";
import {
  CREATE_ORGANIZATION_FAIL,
  CREATE_ORGANIZATION_REQUEST,
  CREATE_ORGANIZATION_SUCCESS,
  GET_BILL_BREAKDOWN_FAIL,
  GET_BILL_BREAKDOWN_REQUEST,
  GET_BILL_BREAKDOWN_SUCCESS,
  GET_BILL_INVOICES_FAIL,
  GET_BILL_INVOICES_REQUEST,
  GET_BILL_INVOICES_SUCCESS,
  GET_CURRENT_BILL_FAIL,
  GET_CURRENT_BILL_REQUEST,
  GET_CURRENT_BILL_SUCCESS,
  GET_ORG_AGENTS_FAIL,
  GET_ORG_AGENTS_REQUEST,
  GET_ORG_AGENTS_SUCCESS,
  GET_ORG_PATIENTS_FAIL,
  GET_ORG_PATIENTS_REQUEST,
  GET_ORG_PATIENTS_SUCCESS,
  GET_ORG_PAYMENT_DETAILS_FAIL,
  GET_ORG_PAYMENT_DETAILS_REQUEST,
  GET_ORG_PAYMENT_DETAILS_SUCCESS,
  GET_ORG_SUBSCRIPTION_FAIL,
  GET_ORG_SUBSCRIPTION_REQUEST,
  GET_ORG_SUBSCRIPTION_SUCCESS,
  GET_ORGANIZATION_FAIL,
  GET_ORGANIZATION_REQUEST,
  GET_ORGANIZATION_SUCCESS,
  GET_PAYMENT_INVOICE_FAIL,
  GET_PAYMENT_INVOICE_REQUEST,
  GET_PAYMENT_INVOICE_SUCCESS,
  RESET_CREATE_ORGANIZATION,
  RESET_PAYMENT_INVOICE,
  UPDATE_ORGANIZATION_FAIL,
  UPDATE_ORGANIZATION_REQUEST,
  UPDATE_ORGANIZATION_SUCCESS,
  PATCH_ORGANIZATION,
} from "../../assets/constants/organizationConstants";
import Cookies from "js-cookie";
import { BASE_URL } from "..";
import { apiRequest } from "../../utils/helpers/api";

// ================= CREATE WORKSPACE/AGENCY REDUCER ==================
export const createOrganizationFunc =
  (organizationObj) => async (dispatch, getState) => {
    try {
      dispatch({ type: CREATE_ORGANIZATION_REQUEST });

      const token = Cookies.get("token");

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/organization/create`,
        organizationObj,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: CREATE_ORGANIZATION_SUCCESS, payload: response?.data });
      Cookies.set("org_id_vita", response?.data?.organization?.id);
    } catch (error) {
      dispatch({
        type: CREATE_ORGANIZATION_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const resetCreateOrgFunc = () => (dispatch) =>
  dispatch({ type: RESET_CREATE_ORGANIZATION });

// ================= GET ORGANIZATION REDUCER ==================
export const getOrganizationFunc = () => async (dispatch) => {
  const orgId = Cookies.get("org_id_vita");

  dispatch({ type: GET_ORGANIZATION_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/organization/get`,
    params: { organization_id: orgId },
  });

  if (data) {
    dispatch({ type: GET_ORGANIZATION_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_ORGANIZATION_FAIL, payload: error });
  }
};

// ================= GET ORGANIZATION AGENTS REDUCER ==================
export const getOrgAgentsFunc = () => async (dispatch) => {
  const orgId = Cookies.get("org_id_vita");

  dispatch({ type: GET_ORG_AGENTS_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/organization/get-agents`,
    params: { organization_id: orgId },
  });

  if (data) {
    dispatch({ type: GET_ORG_AGENTS_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_ORG_AGENTS_FAIL, payload: error });
  }
};

// ================= UPDATE ORGANIZATION REDUCER ==================
export const updateOrganizationFunc = (orgData) => async (dispatch) => {
  const organization_settings = orgData?.organization_settings || {};
  const { logo_url, ...settingsToSave } = organization_settings;

  dispatch({
    type: PATCH_ORGANIZATION,
    payload: {
      ...settingsToSave,
      ...(logo_url !== undefined ? { logo_url } : {}),
    },
  });

  try {
    dispatch({ type: UPDATE_ORGANIZATION_REQUEST });

    const token = Cookies.get("token");

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${BASE_URL}/organization/update`,
      { ...orgData, organization_settings: settingsToSave },
      config
    );

    if (!response?.data?.ok) {
      throw new Error(response?.data?.message);
    }

    dispatch({ type: UPDATE_ORGANIZATION_SUCCESS, payload: response?.data });
  } catch (error) {
    dispatch({
      type: UPDATE_ORGANIZATION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    dispatch(getOrganizationFunc());
  }
};

// ================= GET ORGANIZATION PATIENTS COUNT REDUCER ==================
export const getOrgPatientsCountFunc = () => async (dispatch) => {
  const orgId = Cookies.get("org_id_vita");

  dispatch({ type: GET_ORG_PATIENTS_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/organization/get-patients-count`,
    params: { organization_id: orgId },
  });

  if (data) {
    dispatch({ type: GET_ORG_PATIENTS_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_ORG_PATIENTS_SUCCESS, payload: error });
  }
};

// ================= GET CURRENT MONTH BILL REDUCER ==================
export const getCurrentMonthBillFunc = () => async (dispatch) => {
  const orgId = Cookies.get("org_id_vita");

  dispatch({ type: GET_CURRENT_BILL_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/subscription/get-current-bill`,
    params: { organization_id: orgId },
  });

  if (data) {
    dispatch({ type: GET_CURRENT_BILL_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_CURRENT_BILL_FAIL, payload: error });
  }
};

// ================= GET CURRENT MONTH BILL REDUCER ==================
export const getOrgPaymentDetailsFunc = () => async (dispatch) => {
  const orgId = Cookies.get("org_id_vita");

  dispatch({ type: GET_ORG_PAYMENT_DETAILS_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/subscription/get-payment-details`,
    params: { organization_id: orgId },
  });

  if (data) {
    dispatch({ type: GET_ORG_PAYMENT_DETAILS_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_ORG_PAYMENT_DETAILS_FAIL, payload: error });
  }
};

// ================= GET BILL BREAKDOWN REDUCER ==================
export const getBillBreakdownFunc = () => async (dispatch) => {
  const orgId = Cookies.get("org_id_vita");

  dispatch({ type: GET_BILL_BREAKDOWN_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/subscription/get-practice-breakdown`,
    params: { organization_id: orgId },
  });

  if (data) {
    dispatch({ type: GET_BILL_BREAKDOWN_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_BILL_BREAKDOWN_FAIL, payload: error });
  }
};

// ================= GET ORG SUBSCRIPTION REDUCER ==================
export const getOrgSubscriptionFunc = () => async (dispatch) => {
  const orgId = Cookies.get("org_id_vita");

  dispatch({ type: GET_ORG_SUBSCRIPTION_REQUEST });
  const { data, error } = await apiRequest({
    method: "get",
    url: `/subscription/get-by-organization`,
    params: { organization_id: orgId },
  });

  if (data) {
    dispatch({ type: GET_ORG_SUBSCRIPTION_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_ORG_SUBSCRIPTION_FAIL, payload: error });
  }
};

// ================= GET PAYMENT INVOICE REDUCER ==================
export const getPaymentInvoiceFunc =
  (agencyId, invoiceId, startDate, endDate) => async (dispatch) => {
    try {
      dispatch({ type: GET_PAYMENT_INVOICE_REQUEST });

      const token = Cookies.get("token");

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      let response;

      if (invoiceId === null) {
        response = await axios.get(
          `${BASE_URL}/subscription/export-practice-billables?agency_id=${agencyId}&start_date=${startDate}&end_date=${endDate}`,
          config
        );
      } else {
        response = await axios.get(
          `${BASE_URL}/subscription/export-practice-billables?agency_id=${agencyId}&invoice_id=${invoiceId}&start_date=${startDate}&end_date=${endDate}`,
          config
        );
      }

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: GET_PAYMENT_INVOICE_SUCCESS,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({
        type: GET_PAYMENT_INVOICE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const resetPaymentInvoiceFunc = () => (dispatch) =>
  dispatch({ type: RESET_PAYMENT_INVOICE });

// ================= GET BILL INVOICES REDUCER ==================
export const getBillInvoicesFunc = () => async (dispatch) => {
  const orgId = Cookies.get("org_id_vita");

  dispatch({ type: GET_BILL_INVOICES_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/subscription/get-invoices`,
    params: { organization_id: orgId },
  });

  if (data) {
    dispatch({ type: GET_BILL_INVOICES_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_BILL_INVOICES_FAIL, payload: error });
  }
};
